export const types = {
  loginServer: "[Auth] Login Server",
  checkingFinish: "[Auth] Finish checking login",
  logout: "[Auth] Logout",
  logoutGoogle: "[Auth] Logout Google",
  loginGoogle: "[Auth] Login Google",
};
